/**
 * @generated SignedSource<<4cc22c9f02df7ee27fce6c584811a355>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingSummaryMultipleViewSession_data$data = {
  readonly currentClientProfile: {
    readonly member?: {
      readonly __typename: string;
      readonly club: {
        readonly slug: string;
        readonly " $fragmentSpreads": FragmentRefs<"BookingHeaderFragment_BookingSummary">;
      };
      readonly id?: string;
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentUserHasSeenNotificationNudgeModal_session">;
  readonly " $fragmentType": "BookingSummaryMultipleViewSession_data";
};
export type BookingSummaryMultipleViewSession_data$key = {
  readonly " $data"?: BookingSummaryMultipleViewSession_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingSummaryMultipleViewSession_data">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingSummaryMultipleViewSession_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCurrentUserHasSeenNotificationNudgeModal_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "member",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "BookingHeaderFragment_BookingSummary"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "membershipType",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v0/*: any*/),
                  "type": "Member",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v0/*: any*/),
                  "type": "Customer",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "MemberProfile",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "8799f8db2e1dec8745a91c84800381c2";

export default node;
